import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Note = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24.238 8.825L19.163 3.75C18.038 2.625 16.538 2 14.925 2H11C8.238 2 6 4.237 6 7V25C6 27.762 8.238 30 11 30H21C23.762 30 26 27.762 26 25V13.075C26 11.462 25.375 9.962 24.238 8.825ZM22.825 10.238C23.325 10.738 23.675 11.338 23.85 12H18.2C16.988 12 16 11.012 16 9.8V4.15C16.663 4.338 17.262 4.675 17.762 5.175L22.825 10.238V10.238ZM21 28H11C9.35 28 8 26.65 8 25V7C8 5.35 9.35 4 11 4H14V9.8C14 12.113 15.887 14 18.2 14H24V25C24 26.65 22.65 28 21 28Z" />
	</svg>
);

export default Note;
